export default "/public/app-main/static/image/8bb5759eb50ced84a88f83e2ffdb9016.png";